// extracted by mini-css-extract-plugin
export default {"title":"cashCommon_title__jvTcb","asterisk":"cashCommon_asterisk__8jb8s","text":"cashCommon_text__-2mED"};